import React from "react";

/**
 * Reusable MFA Method Card component for summary section and management modal
 */
const MfaMethodCard = ({
  method,
  isEnrolled,
  isPreferred,
  isSelected,
  onSelect,
  onActivate,
  variant = "summary", // "summary" | "modal"
}) => {
  const isModalVariant = variant === "modal";
  const isDisabled = !isEnrolled && isModalVariant;

  const handleClick = () => {
    if (isModalVariant && isEnrolled && onSelect) {
      onSelect(method.id);
    }
  };

  return (
    <div
      className={`mfa-method-card ${isSelected ? "selected" : ""} ${
        isDisabled ? "disabled" : ""
      }`}
      onClick={handleClick}
      style={{
        border: isSelected ? "2px solid #0052cc" : "1px solid #e2e8f0",
        cursor: isModalVariant && isEnrolled ? "pointer" : "default",
        backgroundColor: isDisabled
          ? "#f8fafc"
          : isSelected
          ? "#f0f7ff"
          : "#ffffff",
        opacity: isDisabled ? 0.6 : 1,
        transition: "all 0.2s ease",
      }}
    >
      <div style={{ flex: 1, marginRight: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {isModalVariant && isEnrolled && (
            <input
              type="radio"
              name="preferred_mfa"
              id={`mfa-${method.id}`}
              value={method.id}
              checked={isSelected}
              onChange={() => onSelect(method.id)}
            />
          )}
          <label
            htmlFor={`mfa-${method.id}`}
            style={{
              fontWeight: "500",
              cursor: isModalVariant && isEnrolled ? "pointer" : "default",
              margin: 0,
              color: isDisabled ? "#94a3b8" : "#1e293b",
              fontSize: "16px",
            }}
          >
            {method.name}
          </label>
        </div>
        <p
          style={{
            color: isDisabled ? "#a1a1aa" : "#64748b",
            marginTop: "4px",
            marginBottom: 0,
          }}
        >
          {method.description}
        </p>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {/* Modal Variant Badges */}
        {isModalVariant ? (
          isSelected && (
            <span
              style={{
                fontSize: "12px",
                backgroundColor: "#dbeafe",
                color: "#1e40af",
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              Preferred
            </span>
          )
        ) : (
          /* Summary Variant Actions / Badges */
          <>
            {isEnrolled ? (
              <>
                <span
                  className="badge badge-active"
                  style={{
                    fontSize: "12px",
                    backgroundColor: "#e2e8f0",
                    color: "#334155",
                    padding: "2px 8px",
                    borderRadius: "4px",
                  }}
                >
                  Active
                </span>

                {isPreferred && (
                  <span
                    className="badge badge-preferred"
                    style={{
                      fontSize: "12px",
                      backgroundColor: "#dbeafe",
                      color: "#1e40af",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      fontWeight: "600",
                    }}
                  >
                    Preferred
                  </span>
                )}
              </>
            ) : (
              <button
                type="button"
                className="cta-button secondary"
                onClick={() => onActivate(method.id)}
              >
                Activate
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MfaMethodCard;
